/*
 * @Author: zhangsheng
 * @Date: 2023-09-13 10:22:04
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-10-07 14:00:21
 * @FilePath: \panda-index-sicermem-frontend\src\common\utils\consts.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
const { origin } = window.location;
// const isDev = process.env.NODE_ENV === 'development';
const LOGIN_TOKEN_KEY = `_${origin}_login_storage_token_key`;
const LOGIN_PATH = '/login';
const DEFAULT_KEY = '/home';
const IMG_ADDRESS_PREFIX = 'http://www.panda.sh.cn/cityinterface/rest/services/filedownload.svc/download';
const MINIO_RESOURCE_PREFIX = '/api';
const FIRSTLEVEL_MENURMAP = new Map([
  ['关于我们', `/aboutus`],
  ['宠物介绍', `/petIntroduction`],
  ['信息查询', `/infoQuery`],
  ['宠物商店', `petShop`],
  ['联系我们', '/contact'],
]);

const INTOPANDA_ROUTE = ['/intoPanda/introduce'];

// 需要监听滚动事件的所有路由
const MONITORSCROLLRoute = [
  '/',
  '/en/',
  '/en',
  // ...INTOPANDA_ROUTE,
];

const inHomeRoute = (pathname: string): Boolean => pathname === '/' || pathname === '/en/' || pathname === '/en';
// const inIntoPandaRoute = (pathname: string): Boolean => !!INTOPANDA_ROUTE.includes(pathname);

const needMonitorScroll = (pathname: string): Boolean => !!MONITORSCROLLRoute.includes(pathname);

export {
  LOGIN_TOKEN_KEY,
  LOGIN_PATH,
  DEFAULT_KEY,
  IMG_ADDRESS_PREFIX,
  MINIO_RESOURCE_PREFIX,
  FIRSTLEVEL_MENURMAP,
  inHomeRoute,
  // inIntoPandaRoute,
  needMonitorScroll,
};
